import { RequestedPackages } from "./RequestedPackages";

export class Packages { 
    RequestedPackages:Array<RequestedPackages> = [];  
}